import LegalLayout, { H2, UL } from "@/components/layout/LegalLayout";

export default function AcceptableUse() {
  return (
    <LegalLayout titleKey="acceptableUse" title="Acceptable Use Policy" testId="legal-aup-page">
      <H2>Purpose</H2>
      <p>This policy governs acceptable use of AtlasForge Financial, Safe to Spend 365, Ember360, and API services.</p>

      <H2>Prohibited Activities</H2>
      <p>Users may not:</p>
      <UL items={["Commit fraud", "Launder money", "Facilitate illegal transactions", "Engage in identity theft", "Access accounts without authorization", "Upload malicious software", "Attempt to exploit vulnerabilities", "Reverse engineer proprietary systems", "Abuse API rate limits", "Interfere with platform operations"]} />

      <H2>Financial Crimes Compliance</H2>
      <p>AtlasForge reserves the right to investigate and report suspected:</p>
      <UL items={["Fraud", "Money laundering", "Sanctions violations", "Terrorist financing", "Identity theft"]} />

      <H2>API Usage</H2>
      <p>Developers may not:</p>
      <UL items={["Scrape customer information", "Circumvent authentication", "Resell access without permission", "Exceed permitted rate limits"]} />

      <H2>Enforcement</H2>
      <p>AtlasForge may suspend or terminate accounts that violate this policy without prior notice.</p>

      <H2>Contact</H2>
      <p>customersupport@atlasforgefinancial.com</p>
      <p>843-291-2556</p>
    </LegalLayout>
  );
}
